import React from 'react';
import classes from './EndChatModal.module.scss';
import Modal from '../Modal/Modal';
import { disconnect } from '../../api/Connect/Connect';
import { setQuickResponses } from '../../store/actions/messages';
import { setResetChat, setShowFeedback } from '../../store/actions/general';
import { disconnectGenesysSession } from '../../store/actions/genesys';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../types/redux';
import { getGenesysConfig, setChatEnded } from '../../utils/config';

const EndChatModal = ({isOpen, closeHandler}) => {
    const { chatId, alias, secureKey, userId, chatEnded } = useSelector((state: RootState) => state.genesys);
    const { mode } = useSelector((state: RootState) => state.messages);

    const dispatch = useDispatch();

    const endChat = () => {
        dispatch(setQuickResponses([]));
        dispatch(setResetChat(false));
        dispatch(disconnectGenesysSession());

        setChatEnded(true);
        if (mode === 'agent') dispatch(setShowFeedback(true));

        disconnect({
            chatId, 
            alias, 
            secureKey,
            userId,
            chatEnded
        }, getGenesysConfig());
    }

    return (
        <Modal isOpen={isOpen} onClose={closeHandler} contentWidth={'60%'}>
            <div className={classes.EndChatModalContainer}>
                <h2>End chat..</h2>
                <div className={classes.EndChatModalContent}>
                    <div className={classes.Label}>Are you sure you want to end this chat session?</div>
                    <div className={classes.Buttons}>
                        <button className={classes.ButtonEnd} onClick={endChat}>End Chat</button>
                        <button className={classes.ButtonCancel} onClick={closeHandler}>Cancel</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EndChatModal;